import { type TomBadge } from '@/ui/primitives/estilos';
import { type LinhaImportacaoCentroCusto, type NaturezaCentroCusto } from '@fiscoai/contracts';

export const NATUREZA: Record<NaturezaCentroCusto, { rotulo: string; tom: TomBadge }> = {
  CUSTO: { rotulo: 'Custo', tom: 'marca' },
  DESPESA: { rotulo: 'Despesa', tom: 'info' },
};

export const OPCOES_NATUREZA = [
  { valor: 'CUSTO', rotulo: 'Custo — produção ou prestação do serviço' },
  { valor: 'DESPESA', rotulo: 'Despesa — administrativo e comercial' },
] as const;

export const ACAO_IMPORTACAO: Record<
  LinhaImportacaoCentroCusto['acao'],
  { rotulo: string; total: (n: number) => string; tom: TomBadge }
> = {
  CRIAR: { rotulo: 'Novo', total: (n) => (n === 1 ? 'novo' : 'novos'), tom: 'sucesso' },
  ATUALIZAR: {
    rotulo: 'Atualiza',
    total: (n) => (n === 1 ? 'atualizado' : 'atualizados'),
    tom: 'info',
  },
  SEM_MUDANCA: { rotulo: 'Sem mudança', total: () => 'sem mudança', tom: 'neutro' },
  ERRO: { rotulo: 'Erro', total: (n) => (n === 1 ? 'erro' : 'erros'), tom: 'perigo' },
};
